import React from "react";
import "react-toastify/dist/ReactToastify.css";
import SolutionsStore from "./SolutionsStore";

export default function ComponentLibrary() {
  return (
    <>
      <SolutionsStore />
    </>
  );
}
